export default {
  apiPath: 'https://api.goodcards-services.com/api',
};
